<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14Vcmg2/tc-custom/9781504045247.jpg?1734221318588" alt="This image is the cover for the book Voodoo Planet, Solar Queen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Voodoo Planet, Solar Queen
      </h1>
      <p class="bookDescription body article font2">
        <b>A gripping story of otherworldly mystery and magic from an acclaimed Grand Master of Fantasy.</b><br/><br/> When Captain Jellico and the crew of the interstellar tramp freighter <i>Solar Queen</i> are invited to visit the planet Khatka by Chief Ranger Asaki, they anticipate a brief respite from the boredom of their mail route. But there is more danger on the verdant jungle world than they know.<br/>  <br/> Founded as a refuge by Earth Africans, Khatka is a global safari where hunters pay big money to pursue the biggest game. But lately Asaki’s battle against ruthless poachers has been undermined by a vicious witch doctor, Lumbrilo, who takes a mortal dislike to the captain and his men.<br/>  <br/> And when their craft crashes while over wild country, Jellico, Asaki and their friends soon find themselves not only hunted by Khatka’s lethal fauna, but by Lumbrilo, who sees his chance to get rid of his enemies once and for all . . .<br/><br/><i>Voodoo Planet is the third book in the Solar Queen Series, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andre Norton
      </h2>
      
      <p class="authorDescription body article">&amp;lt;DIV&amp;gt;For well over a half century, Andre Norton was one of the most popular science fiction and fantasy authors in the world. With series such as Time Traders, Solar Queen, Forerunner, Beast Master, Crosstime, and Janus, as well as many standalone novels, her tales of adventure have drawn countless readers to science fiction. Her fantasy novels, including the bestselling Witch World series, her Magic series, and many other unrelated novels, have been popular with readers for decades. Lauded as a Grand Master by the Science Fiction Writers of America, she is the recipient of a Life Achievement Award from the World Fantasy Convention. An Ohio native, Norton lived for many years in Winter Park, Florida, and died in March 2005 at her home in Murfreesboro, Tennessee.&amp;lt;/DIV&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?696ee90e